import web from "../web";

class PaysService {
    index(token){
        return web.get("/api/pays", { headers: { 'Authorization': 'Bearer '+token } })
    } 
    liste(token){
        return web.get("/api/pays/get_id_nompays", { headers: { 'Authorization': 'Bearer '+token } })
    } 
    index_pays(token){
        return web.get("/api/index_pays", { headers: { 'Authorization': 'Bearer '+token } })
    }

    nationalites(token){
        return web.get("/api/nationalites", { headers: { 'Authorization': 'Bearer '+token } })
    } 
}

export default new PaysService()